import AR_SA from './ar-sa.locale';
import DE_DE from './de-de.locale';
import EN_GB from './en-gb.locale';
import EN_US from './en-us.locale';
import ES_AR from './es-ar.locale';
import ES_CO from './es-co.locale';
import ES_MX from './es-mx.locale';
import PT_BR from './pt-br.locale';

export interface NumberFormat {
  CURRENCY_DESCRIPTION: string;
  CURRENCY_SYMBOL: string;
  DECIMAL_SEPARATOR: string;
  GROUP_SEPARATOR: string;
}

export interface Locale {
  COUNTRY_CODE: string;
  ID: string;
  NUMBER_FORMAT: NumberFormat;
}

const locales: { [key: string]: Locale } = {
  'ar-sa': AR_SA,
  'de-de': DE_DE,
  'en-gb': EN_GB,
  'en-us': EN_US,
  'es-ar': ES_AR,
  'es-co': ES_CO,
  'es-mx': ES_MX,
  'pt-br': PT_BR,
};

function getLocale(lang: string = 'en-us'): Locale {
  return locales[lang] || EN_US;
}

export { getLocale };
